import React from 'react'
import { Icon, IconChoices } from '../../../components/common/Icon'
import { theme } from '../../../theme/theme'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { useEventUserAttendance } from './useEventUserAttendance'
import { Button } from '../../../components/common/Button'
import { EventDetailViewTabs } from './EventDetailView'
import { EventDetailRow } from './EventDetailInformation'
import { EventAttendanceButtons } from './EventAttendanceButtons'
import { IBoardRoomEventModel } from '../../../interfaces/models/boardroom-events.interfaces'
import { IEventModel } from '../../../interfaces/models/events.interfaces'
import { getUserFullName } from '../../../helpers/user'

interface EventAttendancePreviewProps {
  event: IBoardRoomEventModel | IEventModel

  boardRoomEvent: boolean | undefined
  setActiveTab: (tab: EventDetailViewTabs) => void
}

export const EventAttendancePreview = ({
  event,
  boardRoomEvent,
  setActiveTab,
}: EventAttendancePreviewProps): JSX.Element => {
  const { translate } = useAppTranslation()

  const { attending, notAttending } = useEventUserAttendance(event?.attendance)

  const previewLimit = 8
  const attendantsPreview = [...attending, ...notAttending].slice(
    0,
    previewLimit
  )
  return (
    <EventDetailRow
      title={`${translate('eventDetailView.headers.attendants')} (${
        attending.length || 0
      })`}
      content={
        <div className="flex flex-col gap-4">
          {attendantsPreview.length > 0 && (
            <div className="flex flex-col gap-2">
              {attendantsPreview.map((attendant) => (
                <div
                  key={attendant.user._id}
                  className="flex items-center gap-1"
                >
                  <Icon
                    size={16}
                    color={
                      attendant.status === 'attending'
                        ? theme.colors.brandGreen
                        : theme.colors.red
                    }
                    icon={
                      attendant.status === 'attending'
                        ? IconChoices.CHECK_CIRCLE
                        : IconChoices.CLOSE
                    }
                  />
                  <p>{getUserFullName(attendant.user)}</p>
                </div>
              ))}
              {attending.length > previewLimit && (
                <Button
                  label={translate('eventDetailView.buttons.seeAllAttendants')}
                  onClick={() => setActiveTab(EventDetailViewTabs.ATTENDANTS)}
                />
              )}
            </div>
          )}
          <EventAttendanceButtons
            event={event}
            boardRoomEvent={boardRoomEvent}
          />
        </div>
      }
    />
  )
}
